import { Component, ElementRef, ViewChild } from '@angular/core';
import { PanelContainerComponent } from 'src/app/shared/content-panels';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PanelHeaderComponent } from 'src/app/shared/content-panels';
import { PanelBodyComponent } from 'src/app/shared/content-panels';
import { WebSocketService } from 'src/app/shared/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelectChange } from '@angular/material/select';
import { ApolloClient } from '@apollo/client';
import { QBuiltService } from '../services/qbuilt-service';
import { HbgSnackBar } from 'src/app/shared/toaster/hbg-toaster';

@Component({
  selector: 'csv-file-upload',
  imports: [
    PanelContainerComponent,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    PanelHeaderComponent,
    PanelBodyComponent,
  ],
  templateUrl: './csv-file-upload.component.html',
  styleUrl: './csv-file-upload.component.scss',
})
export class CsvFileUploadComponent {
  pageTitle: string = 'Upload CSV File';
  pagedesc: string = "Attach CSV file then click 'Upload'";
  uploadBtnText: string = 'Upload';
  dropdownPlaceholder: string = 'Select QBuilt Item Type...';

  validFields: boolean = false;
  selectedFileTypeValue: number;
  fileData: any;
  base64String: string | ArrayBuffer | null = null;

  fileName: string = '';
  incorrectFileType: boolean = false;
  warningText: string = '';

  @ViewChild('fileInput') myFileInput: ElementRef;

  constructor(
    private service: QBuiltService,
    private toaster: HbgSnackBar,
  ) {}

  onSelectionChange(event: MatSelectChange) {
    this.selectedFileTypeValue = event.value;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (file.name.toLowerCase().endsWith('.csv')) {
      this.fileData = file;
      this.incorrectFileType = false;
      this.validFields = true;
      this.fileName = file.name;
      this.convertToBase64(this.fileData);
    } else {
      this.validFields = false;
      this.incorrectFileType = true;
      this.warningText = 'Incorrect File Type: Only .csv files accepted';
    }
  }

  convertToBase64(file: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        const parts = reader.result.split(',');
        this.base64String = parts.length > 1 ? parts[1] : reader.result;
      } else {
        this.base64String = reader.result;
      }
    };

    reader.onerror = (error) => {
      console.error('Error converting file to Base64:', error);
    };
  }

  uploadFile() {
    this.service.uploadTasks(this.base64String.toString()).subscribe({
      next: (value) => {
        if (!value) {
          this.toaster.error('Error uploading CSV file!');
          console.error('Error uploading CSV file:', value.Message);
          return;
        }

        this.resetValues();
        this.toaster.open('CSV file uploaded successfully!');
      },
      error: (err) => {
        this.toaster.error('Error uploading CSV file!');
        console.error('Error uploading CSV file:', err);
      },
    });
  }

  resetValues() {
    this.selectedFileTypeValue = null;
    this.fileData = null;
    this.base64String = null;
    this.fileName = '';
    this.validFields = false;
    this.incorrectFileType = false;
    this.warningText = '';
    if (this.myFileInput) {
      this.myFileInput.nativeElement.value = null; // or ''
    }
  }
}
